import FCellCreditorNameMDP from "@/components/table/cell/FCellCreditorNameMDP";
import FCellRouterLinkMDP from "@/components/table/cell/FCellRouterLinkMDP";
import FDataTableMDP, { ActionType } from "@/components/table/FDataTableMDP";
import FInfoHighlightMDP from "@/components/table/info/FInfoHighlightMDP";

export default class ChppCreditorInfoFDataTableMDP extends FDataTableMDP {
  parent: any;
  constructor({ parent }: { parent: any }) {
    super({
      title: "Creditors",
      myRefName: "ChppCreditorInfoRef",
      itemKey: "fiCreditorId",
    });
    this.parent = parent;

    this.addColumn({
      label: "Creditor  Name",
      dataSelectorKey: "creditorName",
      columnCellMDP: new FCellCreditorNameMDP({
        clientFileId: this.parent.cfID,
        target: "_blank"
      }),
    })
      .addCurrencyColumn({
        label: "Total  Debt",
        dataSelectorKey: "totalDebt",
      })
      .addDateColumn({
        label: "Last  Payment  Date",
        dataSelectorKey: "lastPaymentDate",
      })
      .addNumberColumn({
        label: "Delinquency  As  Of  Enrollment",
        dataSelectorKey: "delinquencyAsOfEnrollment",
      })
      .addNumberColumn({
        label: "Delinquency  As  Of  Date",
        dataSelectorKey: "delinquencyAsOfDate",
      })
      .addColumn({
        label: "Debt  Type",
        dataSelectorKey: "debtType",
      })
      .addStatusColumn({
        label: "Status",
        dataSelectorKey: "status",
      })
      .addAction({
        label: "Add Creditor Notes",
        onClick: (item) => {
          return new Promise((res) => {
            this.parent.handleCreditorSelect(item);
          });
        },
        type: ActionType.OTHERS,
        singleSelect: true,
      })
      .addAction({
        label: "Client File Notes",
        onClick: () => {
          return new Promise((res) => {
            this.parent.showClientFileNotes = true;
          });
        },
        type: ActionType.OTHERS,
        noSelect: true,
      })

      .addAction({
        label: "Client File Details",
        onClick: () => {
          return new Promise((res) => {
            this.parent.handleAddClientFileDetailsClick();
          });
        },
        type: ActionType.OTHERS,
        noSelect: true,
      })

      .addAction({
        label: "Collect Payment",
        onClick: () => {
          return new Promise((res) => {
            this.parent.toggleCollectPaymentDrawer();
          });
        },
        type: ActionType.OTHERS,
        noSelect: true,
      })
      .addInfo({
        label: "Name",
        value: this.parent.customerDetails?.customerFullName,
        infoMDP: new FInfoHighlightMDP({ icon: "mdi-account" }),
      })
      .addInfo({
        label: "KFS ID",
        value: this.parent.customerDetails?.clientFileNumber,
        infoMDP: new FInfoHighlightMDP({ icon: "mdi-account" }),
      });
  }
}
